/**
 * Color Contrast Utility
 *
 * Computes perceived luminance of a hex color and returns
 * an appropriate text color for readability.
 */

/**
 * Returns a contrasting text color (off-white or charcoal) based on the
 * perceived luminance of the given hex background color.
 */
export function getContrastTextColor(color: string): '#F5F5F5' | '#1A1A1A' {
  let r: number, g: number, b: number;

  // Handle rgb() format
  const rgbMatch = color.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/);
  if (rgbMatch) {
    r = parseInt(rgbMatch[1], 10);
    g = parseInt(rgbMatch[2], 10);
    b = parseInt(rgbMatch[3], 10);
  } else {
    // Handle hex format
    const hex = color.replace('#', '');
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  }

  // Perceived luminance (ITU-R BT.601)
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

  return luminance < 128 ? '#F5F5F5' : '#1A1A1A';
}
